export const ACTION_SUBSCRIBE = '/Account/Subscribe';

export const ACTION_GET_STATUS_SUBSCRIBE = '/Account/GetStatusSubscribe';